import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Calendar, Phone } from "lucide-react";
import { useContent } from "../../contexts/ContentContext";
import { setConsultSource } from "../../lib/consultSource";

export default function PageHeader({ areaId, areaTitle }) {
  const { firm } = useContent();
  const consultHref = areaId ? `/?area=${areaId}#contact` : "/#contact";
  const source = areaTitle ? `${areaTitle} — practice area page (header)` : "Pay Online page (header)";
  return (
    <header className="bg-[#0c1729] text-white border-b border-white/10" data-testid="practice-page-header">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
        <Link to="/" className="flex flex-col leading-tight" data-testid="header-home-link">
          <span className="font-serif text-lg md:text-xl tracking-wide leading-none">Hilty, Bower, Haws &amp; Seable</span>
          <span className="text-[10px] uppercase tracking-[0.3em] text-[#d4b87a] mt-1.5">PLLC &middot; Attorneys at Law</span>
        </Link>
        <div className="flex items-center gap-3 md:gap-5">
          {firm?.phones?.[0] && (
            <a href={`tel:${firm.phones[0].replace(/\D/g, "")}`} className="hidden md:flex items-center gap-2 text-sm hover:text-[#d4b87a]">
              <Phone className="w-4 h-4 text-[#d4b87a]" /> {firm.phones[0]}
            </a>
          )}
          <Link
            to="/"
            className="hidden sm:inline-flex items-center gap-2 h-10 px-4 border border-white/30 text-[11px] uppercase tracking-[0.18em] hover:bg-white hover:text-[#0c1729] transition-colors"
            data-testid="back-home-button"
          >
            <ArrowLeft className="w-4 h-4" /> Home
          </Link>
          <Link
            to={consultHref}
            onClick={() => setConsultSource(source)}
            className="inline-flex items-center gap-2 h-10 px-4 md:px-5 bg-[#b8924a] hover:bg-[#a07f3e] text-[11px] uppercase tracking-[0.18em] transition-colors"
            data-testid="header-consult-button"
          >
            <Calendar className="w-4 h-4" /> <span className="hidden sm:inline">Schedule a</span> Consultation
          </Link>
        </div>
      </div>
    </header>
  );
}
